import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { ErrorBanner, Field } from "../components/ui";
import { useAuth } from "../lib/AuthContext";

export function SignInPage() {
  const { signIn, signedIn } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | undefined>();
  const [busy, setBusy] = useState(false);

  const returnTo = (location.state as { from?: string } | null)?.from ?? "/";
  if (signedIn) {
    navigate(returnTo, { replace: true });
  }

  async function submit(event: React.FormEvent) {
    event.preventDefault();
    setBusy(true);
    setError(undefined);
    try {
      await signIn(email, password);
      navigate(returnTo, { replace: true });
    } catch (cause) {
      setError(cause instanceof Error ? cause.message : String(cause));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="auth-page">
      <form className="auth-card" onSubmit={(event) => void submit(event)}>
        <div className="auth-card__brand">
          <strong>Discovery</strong>
          <span>Operational knowledge, verified</span>
        </div>

        <ErrorBanner error={error} />

        <Field label="Email">
          <input
            type="email"
            autoComplete="username"
            autoFocus
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            required
          />
        </Field>
        <Field label="Password">
          <input
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            required
          />
        </Field>

        <button className="primary" type="submit" disabled={busy} style={{ width: "100%" }}>
          {busy ? "Signing in…" : "Sign in"}
        </button>

        <p className="tiny muted" style={{ marginBottom: 0 }}>
          Been invited? Open the link in your invitation email — it signs you in as it goes.
        </p>
      </form>
    </div>
  );
}
